import React from 'react';

const Select = ({ ...rest }) => {
  return <nsemble-select {...rest} />;
};

export default Select;
